"use client";
import { useUserContext } from "@/context/UserContext";
import { GalleryI } from "@/interfaces/galleries/Galleries";

interface SubscriptionButtonPropsI {
  gallery: GalleryI;
  subToGallery: () => void;
  loadingSub: boolean;
}

function SubscriptionButton(props: SubscriptionButtonPropsI) {
  const { gallery, subToGallery, loadingSub } = props;
  const { currentUser } = useUserContext();
  if (!currentUser) return <></>;

  return !gallery.subscriptor.includes(currentUser._id) ? (
    <button
      className="btn linear-bg"
      onClick={subToGallery}
      disabled={loadingSub}
    >
      Subscribe
    </button>
  ) : (
    <button
      className="btn linear-bg"
      onClick={subToGallery}
      disabled={loadingSub}
    >
      Unsubscribe
    </button>
  );
}

export default SubscriptionButton;
